import React from 'react'
import { useTranslation } from 'react-i18next'

import { FulfilmentWhenLabel } from '@src/components/FulfilmentWhenLabel/FulfilmentWhenLabel'
import { FulfilmentWhereLabel } from '@src/components/FulfilmentWhereLabel/FulfilmentWhereLabel'
import { DotSeparatedList } from '@src/components/DotSpan/DotSeparatedList'
import { OutletFulfilmentStateType } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'
import { useBottomSheetStack } from '@src/hooks/useBottomSheetStack/useBottomSheetStack'
import { BagDeliverySVG } from '@src/images/BagDelivery'

import {
  FulfilmentContainer,
  FulfilmentDetailsContainer,
  PaddedDotSpan,
} from './FulfilmentTabStyles'
import { StyledDoubleArrowSVG } from './OutletHeaderMobileStyles'
import { CurrentFulfilmentType } from '../../../hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/validation'
import { useOutletPageContext } from '../OutletPageContext'

export enum TabString {
  SERVICE = 'SERVICE',
  WHEN = 'WHEN',
  LOCATION = 'LOCATION',
  WHERE = 'WHERE',
}

export const HeaderTab: React.FC<{
  fulfilmentTabs: TabString[]
  permanentCheckout?: boolean
  dataTestId?: string
}> = ({ fulfilmentTabs, permanentCheckout = false, dataTestId }) => {
  const { serviceComponentBottomSheetController } = useBottomSheetStack()
  const { t } = useTranslation('outletHeader')
  const {
    outletFulfilment: {
      outlet,
      data: { currentFulfilment },
    },
  } = useOutletPageContext()
  const currentFulfilmentType = currentFulfilment.type

  const selectedNarrowFulfilment = currentFulfilment.narrowType

  const shouldShowWhereLabel = () => {
    if (currentFulfilmentType === CurrentFulfilmentType.COLLECTION) return false

    if (
      (currentFulfilmentType === CurrentFulfilmentType.TABLE_UNSELECTED &&
        outlet.isPendingTableNumbersEnabled) ||
      (currentFulfilmentType === CurrentFulfilmentType.TABLE &&
        outlet.isPendingTableNumbersEnabled &&
        !currentFulfilment.tableId)
    )
      return false

    return true
  }

  const listItems = [
    fulfilmentTabs?.includes(TabString.SERVICE) &&
      t(selectedNarrowFulfilment.toLowerCase()),

    fulfilmentTabs?.includes(TabString.WHEN) && (
      <FulfilmentWhenLabel
        key="when-label"
        stateType={OutletFulfilmentStateType.GLOBAL}
      />
    ),

    (fulfilmentTabs?.includes(TabString.LOCATION) ||
      fulfilmentTabs?.includes(TabString.WHERE)) &&
      shouldShowWhereLabel() && (
        <FulfilmentWhereLabel
          key="where-label"
          stateType={OutletFulfilmentStateType.GLOBAL}
        />
      ),
  ]

  return (
    <FulfilmentContainer
      onClick={serviceComponentBottomSheetController.open}
      data-test-id={dataTestId}
    >
      <BagDeliverySVG id="service" />
      <FulfilmentDetailsContainer permanentCheckout={permanentCheckout}>
        <DotSeparatedList dotSpan={<PaddedDotSpan>{'•'}</PaddedDotSpan>}>
          {listItems}
        </DotSeparatedList>
      </FulfilmentDetailsContainer>
      <StyledDoubleArrowSVG id="fulfilmentArrow" />
    </FulfilmentContainer>
  )
}
